var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundedX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5.5C11 8.53757 8.53757 11 5.5 11C2.46243 11 0 8.53757 0 5.5C0 2.46243 2.46243 0 5.5 0C8.53757 0 11 2.46243 11 5.5ZM3.1453 3.84687C2.95157 3.65313 2.95157 3.33903 3.1453 3.1453C3.33903 2.95157 3.65313 2.95157 3.84687 3.1453L5.5 4.79843L7.15313 3.1453C7.34687 2.95157 7.66097 2.95157 7.8547 3.1453C8.04843 3.33903 8.04843 3.65313 7.8547 3.84687L6.20157 5.5L7.8547 7.15313C8.04843 7.34687 8.04843 7.66097 7.8547 7.8547C7.66097 8.04843 7.34687 8.04843 7.15313 7.8547L5.5 6.20157L3.84687 7.8547C3.65313 8.04843 3.33903 8.04843 3.1453 7.8547C2.95157 7.66097 2.95157 7.34687 3.1453 7.15313L4.79843 5.5L3.1453 3.84687Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedX);
export default __webpack_public_path__ + "static/media/rounded-x.a6b5d47464c59a8d77804319626cf246.svg";
export { ForwardRef as ReactComponent };